import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import Button from '../../../../../components/Button';
import useLoginPlaidLink from '../../../../../hooks/useLoginPlaidLink';
import { useConfig } from '../../../../../providers/ConfigProvider';
import DismissAction from '../DismissAction';

import styles from '../../GlobalBanner.module.scss';
import secondaryStyles from './BankAccountLoginExpiring.module.scss';

const BankAccountLoginExpiring = ({ bannerId, expiresAt, itemId }) => {
  const { PRIVATE_BASE_PATH } = useConfig();
  const expiresIn = moment(expiresAt).fromNow(true);
  const { open, loading } = useLoginPlaidLink({ itemId });

  return (
    <div className={styles['gb-style-warning']}>
      <div className={secondaryStyles.content}>
        Plaid connection with your bank account will expire in {expiresIn}.
        Please login in again to extend the connection.
        <Button
          variant="ghost"
          small
          className={secondaryStyles.button}
          to={`${PRIVATE_BASE_PATH}settings/payment-methods`}
          loading={loading}
          disabled={loading}
          onClick={open}
        >
          Log in
        </Button>
      </div>
      <DismissAction bannerId={bannerId} />
    </div>
  );
};

BankAccountLoginExpiring.propTypes = {
  bannerId: PropTypes.string.isRequired,
  expiresAt: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
};

export default BankAccountLoginExpiring;
